// Phase A (rev3 M4): how an effective-support-level change came about, as the
// four escalation_logs columns trigger_event / trigger_axis / manual_or_auto /
// rule_id. Pure so the precedence is pinned by tests:
//   1. a manual change from the level selector,
//   2. a bump rule (axis + the condition that fired),
//   3. a static floor lifting the level,
//   4. otherwise the context that held a bump went away (a decrease).
export const MANUAL_SELECTION = Object.freeze({
  manual_or_auto: 'manual',
  trigger_event: 'manual_selection',
  trigger_axis: null,
  rule_id: 'manual.selector.v1',
});

export const describeEscalationCause = ({
  manual = false,
  previousLevel = null,
  newLevel = null,
  triggerReason = null,
  triggerEvent = null,
  ruleId = null,
  floorRuleId = null,
} = {}) => {
  if (manual) return { ...MANUAL_SELECTION };
  if (triggerEvent && ruleId) {
    return {
      manual_or_auto: 'auto',
      trigger_event: triggerEvent,
      trigger_axis: triggerReason || null,
      rule_id: ruleId,
    };
  }
  if (floorRuleId && previousLevel != null && newLevel != null && newLevel > previousLevel) {
    const axis = floorRuleId.split('.')[1] || null;
    return {
      manual_or_auto: 'auto',
      trigger_event: 'static_floor',
      trigger_axis: axis,
      rule_id: floorRuleId,
    };
  }
  return {
    manual_or_auto: 'auto',
    trigger_event: 'context_reset',
    trigger_axis: null,
    rule_id: 'reset.context.v1',
  };
};
